import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import logo from "../assets/images/knackhire-new.png";
import axios from "axios";
import { GetClients } from "../apiconstants/constants";
import Swal from "sweetalert2";

const Navbar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showWarning, setShowWarning] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   axios
  //     .get(GetClients.APIURL)
  //     .then((response) =>  { 
  //     setClients(response.data.filter((x)=>x.isActive===true))})
     
  //     .catch((error) => console.error("Error fetching clients", error));
  // }, []);
    useEffect(() => {
    const cachedClients = localStorage.getItem("clientsCache");
    if (cachedClients) {
      setClients(JSON.parse(cachedClients));
    }
  }, []);

  // Normalize text by removing spaces and converting to lowercase
  const normalizeText = (text) => text?.toLowerCase().replace(/\s+/g, "");

  const filteredClients = clients.filter((client) =>
    normalizeText(client.companyName)?.includes(normalizeText(searchTerm))
  );

  // Show warning if no client matches
  useEffect(() => {
    setShowWarning(searchTerm && filteredClients.length === 0);
  }, [searchTerm, filteredClients]);

  const handleSelectClient = (client) => {
    console.log("nnn",client)
    setSelectedClient(client);
    setSearchTerm(client.companyName);
    setShowWarning(false);
  };

  const handleGoClick = () => {
    if (!selectedClient) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Please select a client",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
    navigate(`/Login?clientId=${selectedClient.guid}`);
    localStorage.setItem("clientData", JSON.stringify(selectedClient));
    localStorage.setItem("clientID", selectedClient.guid);
  };

  return (
    <div class="" style={{ paddingTop: "150px" }}>
    <div
      style={{
        width: "370px",
        height: "400px",
        margin: "auto",
        paddingTop: "40px",
        paddingBottom: "40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "#f8f8f8",
        border: "1px solid #00a7ac26",
        borderRadius: 20,
      }}
    >
      <a className="navbar-brand mb-2" href="#">
        <img src={logo} className="img-fluid" alt="logo" />
      </a>
  
      <div style={{ flexGrow: 1, width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div className="d-flex justify-space-between">
          <div style={{ width: "250px", position: "relative" }}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setSelectedClient(null);
              }}
              placeholder="Search Client"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #00a7ac",
              }}
            />
            <FaSearch
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#00a7ac",
                cursor: "pointer",
              }}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <button
              class="btn btn-primary"
              onClick={handleGoClick}
              style={{
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "16px",
                color: "#fff",
                backgroundColor: "#00a7ac",
                borderRadius: "25px",
                marginLeft: 10,
              }}
            >
              Go
            </button>
          </div>
        </div>
  
        {searchTerm && !selectedClient && filteredClients.length > 0 && (
          <ul
            style={{
              listStyleType: "none",
              marginRight:"auto",
              marginLeft:"30px",
              padding: 0,
              width: "248px",
              background: "#fff",
              border: "1px solid #ddd",
              maxHeight: "120px",
              overflow: "auto",
              marginTop: "5px",
              borderRadius: "5px",
              float:"left"
            }}
          >
            {filteredClients.map((client) => (
              <li
                key={client.clientId}
                onClick={() => handleSelectClient(client)}
                style={{
                  padding: "10px",
                  cursor: "pointer",
                  borderBottom: "1px solid #ddd",
                  fontSize: 14,
                }}
              >
                {client.companyName}
              </li>
            ))}
          </ul>
        )}
  
        {showWarning && (
          <p style={{ color: "red", marginTop: "5px", fontSize: 14 }}>Client does not exist</p>
        )}
      </div>
       <Link to="/Register">
        <p style={{ fontSize: 14, fontWeight: "bold", color: "#00a7ac", marginBottom: "10px" }}>
         Register
        </p>
      </Link>
  
      <Link to="/SuperAdminLogin">
        <p style={{ fontSize: 14, fontWeight: "bold", color: "#00a7ac", marginBottom: "10px" }}>
          Login as Super Admin
        </p>
      </Link>
      <Link to="/">
        <p style={{ fontSize: 14, fontWeight: "bold", color: "#00a7ac", marginBottom: "10px" }}>
        <i className="fa fa-arrow-left" ></i>  Back
        </p>
      </Link>
    </div>
  </div>
  
  );
};

export default Navbar;
